<template>
  <div>
    <v-layout row align-center>
      <v-text-field
        :label="$t('PNR-No')"
        :rules="rules"
        @blur="test()"
        :disabled="active"
        :placeholder="kodmesajı"
        append-icon="list"
        @click:append="dialogac()"
        :tabindex="tabdeger"
        v-model="val"
        hide-details=""
      >
      </v-text-field>
    </v-layout>

    <v-dialog scrollable="" persistent v-model="dialog" max-width="1500px">
      <v-card flat color="grey lighten-5">
        <v-toolbar size="120px" color="info">
          <v-toolbar-title class="white--text">{{$t('PNR-List')}}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-layout row="" wrap="">
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 pb-2 sm12 v-if="satici != undefined" md12>
                  <v-radio-group hide-details row v-model="pnrtip">
                    <v-radio :label="$t('All-Pnr')" :value="false"></v-radio>
                    <v-radio :label="pnretiket" :value="true"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-bind:detaygizle="true"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="prm.Kayit_Tarihi1"
                    v-model="prm.Kayit_Tarihi1"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    v-bind:detaygizle="true"
                    v-bind:defaultvalue="'ok'"
                    v-bind:value="prm.Kayit_Tarihi2"
                    v-model="prm.Kayit_Tarihi2"
                  ></tarihcomp>
                </v-flex>


                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Check-in-Date') + '1'"
                    v-bind:detaygizle="true"
                    
                    v-bind:value="prm.Giris_Tarihi1"
                    v-model="prm.Giris_Tarihi1"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Check-in-Date') + '2'"
                    v-bind:detaygizle="true"
                   
                    v-bind:value="prm.Giris_Tarihi2"
                    v-model="prm.Giris_Tarihi2"
                  ></tarihcomp>
                </v-flex>


                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Check-out-Date') + '1'"
                    v-bind:detaygizle="true"
                   
                    v-bind:value="prm.Cikis_Tarihi1"
                    v-model="prm.Cikis_Tarihi1"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <tarihcomp
                    :etiket="$t('Check-out-Date') +  '2'"
                    v-bind:detaygizle="true"
                    
                    v-bind:value="prm.Cikis_Tarihi2"
                    v-model="prm.Cikis_Tarihi2"
                  ></tarihcomp>
                </v-flex>

              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                v-model="prm.Isim"
                :label="$t('Name')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <v-text-field
                hide-details
                v-model="prm.KarsiRezKod"
                :label="$t('Counter-Booking-Code')"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <v-select
                clearable
                :items="SaticiTip"
                item-text="Aciklama"
                item-value="Kod"
                v-model="prm.SaticiTip"
                :label="$t('Seller-Type')"
                hide-details=""
                @click.native="prm.SaticiKod = null"
              >
              </v-select>
            </v-flex>
            <v-flex xs12 sm12 md6>
              <genelarama
                :autofocuss="true"
                apiname="SaticiAra"
                :tip="prm.SaticiTip"
                :label="$t('Seller-Code')"
                v-model="prm.SaticiKod"
              ></genelarama>
            </v-flex>
            <v-flex xs12 sm12 md12>
              <cariaracomp
                v-bind:etiket="$t('Currentcode_label')"
                v-bind:value="secilencari"
                v-model="secilencari"
                :Coper="true"
              ></cariaracomp>
            </v-flex>

            <v-flex xs12 pt-2 sm4 pr-2 md12>
              <v-layout row fill-height justify-end full-width align-end="">
                <v-btn
                  v-if="!pnrkalemloading"
                  @click="Ara()"
                  outline
                  color="info"
                  >Ara
                </v-btn>
                <v-layout
                  v-if="pnrkalemloading"
                  row
                  fill-height
                  justify-end
                  full-width
                  align-end=""
                >
                  <v-progress-circular
                    indeterminate
                    :width="4"
                    color="info"
                  ></v-progress-circular>
                </v-layout>
              </v-layout>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card-actions>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-toolbar flat="" size="100px" dark color="info">
                        <v-toolbar-title>
                          <span class="subheading white--text">
                            {{  $t('PNR-found') }}
                          </span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-flex xs6 sm6 md6>
                          <v-text-field
                            flat=""
                            solo-inverted=""
                            hide-details
                            v-model="searchsatilanbilet"
                            :label="$t('search-records')"
                            append-icon="search"
                          ></v-text-field>
                        </v-flex>
                      </v-toolbar>
                    </v-flex>
                    <v-flex xs12 sm12 md12>
                      <v-data-table
                        :headers="headersservis"
                        :loading="progress"
                        :search="searchsatilanbilet"
                        :items="items"
                        hide-actions
                        class="elevation-1"
                      >
                        <v-progress-linear
                          slot="progress"
                          indeterminate
                        ></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr @click="kabul(props.item)" item>
                            <td class="text-xs-left">
                              {{ props.item.PNR_No }}
                            </td>
                            <td class="text-xs-left">{{ props.item.Isim }}</td>
                            <td class="text-xs-left">
                              {{ props.item.Cari_Kod }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.Kayit_Tarihi | dateformat }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.Donem1 | dateformat }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.Donem2 | dateformat }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.SaticiKod }}
                            </td>
                            <td class="text-xs-left">
                              {{ props.item.CariUnvan }}
                            </td>
                            <td class="justify-center layout px-0"></td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="filtreiptal()">
            {{ $t("cancel_button") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
      <v-snackbar
        :timeout="timeout"
        :top="y === 'top'"
        :bottom="y === 'bottom'"
        :right="x === 'right'"
        :left="x === 'left'"
        :multi-line="mode === 'multi-line'"
        :vertical="mode === 'vertical'"
        v-model="snackbar"
      >
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>


<script>
import auth from "../../../../api/auth";
import tarihcomp from "@/components/app/customcomp/tarihim.vue";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import tool from "../tools";
import helpers from "@/components/app/customcomp/helpers.js";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";

export default {
  props: ["value", "tabdeger", "active", "rules", "satici", "tip"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },

  beforeMount: beforeMount,
  components: {
    tarihcomp,
    genelarama,
    cariaracomp,
    genelarama,
  },
  methods: {
    test() {
      this.$emit("odakkaybi", this.val);
    },

    filtreiptal() {
      this.prm.Isim = null;
      this.prm.Kayit_Tarihi1 = null;
      this.prm.Kayit_Tarihi2 = null;
      
      this.prm.Giris_Tarihi1 = null;
      this.prm.Giris_Tarihi2 = null;

      this.prm.Cikis_Tarihi1 = null;
      this.prm.Cikis_Tarihi2 = null;


      this.prm.Cari_Kod = null;
      this.secilencari = null;
      this.dialog = false;
    },
    Ara() {
      this.pnrkalemloading = true;
      this.items = [];
      var saticiKod;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));


      this.prm.SirketNo = credentials.CoperSirketNo;
      if (this.prm.SaticiKod == null) {
        if (this.pnrtip == false) {
          saticiKod = null;
        } else {
          if (this.satici != undefined) {
            saticiKod = this.satici.kod;
          } else {
            saticiKod = null;
          }
        }
      } else {
        if (this.prm.SaticiKod != undefined) {
          saticiKod = this.prm.SaticiKod.kod;
        } else {
          saticiKod = null;
        }
      }

      if (this.prm.SaticiTip == null) {
        if (this.pnrtip == false) {
          this.prm.SaticiTip = null;
        } else {
          if (this.tip != undefined) {
            this.prm.SaticiTip = this.tip;
          } else {
            this.prm.SaticiTip = null;
          }
        }
      }

      if (this.secilencari != null) {
        this.prm.Cari_Kod = this.secilencari.id;
      } else {
        this.prm.Cari_Kod = null;
      }

      var params = {
        Isim:this.prm.Isim,
        Cari_Kod:this.prm.Cari_Kod,
        Kayit_Tarihi1:this.prm.Kayit_Tarihi1,
        Kayit_Tarihi2:this.prm.Kayit_Tarihi2,

        Giris_Tarihi1 : this.prm.Giris_Tarihi1,
        Giris_Tarihi2 : this.prm.Giris_Tarihi2,

        Cikis_Tarihi1 : this.prm.Cikis_Tarihi1,
        Cikis_Tarihi2 : this.prm.Cikis_Tarihi2,



        KarsiRezKod:this.prm.KarsiRezKod,
        SirketNo:this.prm.SirketNo,
        SaticiTip:this.prm.SaticiTip,
        SaticiKod:saticiKod
      }
      setTimeout(() => {
        tool.http_post(this, "PNRAra", params).then(
          (response) => {
            this.items = response.body;
            this.pnrkalemloading = false;
          },
          (response) => {
            this.status = tool.responseToStatus(response);
            this.pnrkalemloading = false;
          }
        );
      }, 500);
    },
    kayitgetir: kayitgetir,
    dialogac: dialogac,
    kabul: kabul,
    codeControl: codeControl,
  },
  data() {
    return {
      SaticiTip: [
        {
          Aciklama: this.$t('Hotel'),
          Kod: 1,
        },
        {
          Aciklama: "Arac",
          Kod: 2,
        },
        {
          Aciklama: "Restaurant",
          Kod: 3,
        },
        {
          Aciklama: "Acente",
          Kod: 4,
        },
        {
          Aciklama: "RentACar",
          Kod: 5,
        },
        {
          Aciklama: "Rehber",
          Kod: 6,
        },
        {
          Aciklama: "Muze",
          Kod: 7,
        },
        {
          Aciklama: "Charter",
          Kod: 8,
        },
        {
          Aciklama: this.$t('Cruise'),
          Kod: 9,
        },
        {
          Aciklama: "Diger",
          Kod: 10,
        },
        {
          Aciklama: "Vize",
          Kod: 11,
        },
        {
          Aciklama: "TurOperatoru",
          Kod: 12,
        },
        {
          Aciklama: this.$t('Consulate'),
          Kod: 13,
        },
        {
          Aciklama: "Sigorta",
          Kod: 14,
        },
        {
          Aciklama: "Feribot",
          Kod: 15,
        },
        {
          Aciklama: "Golf",
          Kod: 16,
        },
      ],
      pnrkalemloading: false,
      pnretiket: null,
      pnrtip: false,
      searchsatilanbilet: null,
      secilencari: null,
      prm: {
        Isim: null,
        Cari_Kod: null,
        Kayit_Tarihi1: null,
        Kayit_Tarihi2: null,

        Giris_Tarihi1 : null,
        Giris_Tarihi2 : null,

        Cikis_Tarihi1 : null,
        Cikis_Tarihi2 : null,

        KarsiRezKod: null,
        SirketNo: null,
        SaticiTip: null,
        SaticiKod: null,
      },
      headersservis: [
        {
          text: "PNR",
          value: "BolumKodu",
        },
        {
          text: this.$t('Name'),
          value: "BolumAdi",
        },
        {
          text: this.$t('Current'),
          value: "BolumAdi",
        },
        {
          text: this.$t('Date'),
          value: "BolumAdi",
        },

        {
          text: this.$t('Check-in-Date'),
          value: "Donem1",
        },

        {
          text: this.$t('Check-out-Date'),
          value: "Donem2",
        },

        {
          text: this.$t('Seller-Code'),
          value: "SaticiKod",
        },

        {
          text: this.$t('Current-Title'),
          value: "CariUnvan",
        },

      ],
      kodmesajı: null,
      progress: false,
      items: [],
      aranacakkelime: null,
      secilendeger: null,
      dialog: false,

      text1: null,
      loading: false,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
    };
  },

  watch: {
    secilendeger(val) {
      val && this.kayitgetir(val);
    },
    dialog(val2) {
      if (!val2) return;
      requestAnimationFrame(() => {
        //  this.$refs.ara.focus()
      });
    },
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },
    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
  },
};

function codeControl() {
  if (this.val != null && this.val != "") {
    var credentials = JSON.parse(window.localStorage.getItem("credentials"));
    var params1 = {
      CompanyCode: credentials.SirketKodu,
      SectionCode: escape(this.val),
    };
    this.$http
      .post(auth.API_URL + "api/Definitions/SectionGet", params1, {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
        },
      })
      .then(
        (response) => {
          if (response.body.length == 1) {
            this.val = response.body[0].BolumKodu;
            this.kodmesajı = null;
          } else {
            this.kodmesajı = this.$t('Incorrect-code-entry')
            this.val = null;
          }
        },
        (response) => {
          if (response.status === 0) {
            this.text1 = "Service Unavailable-bolum";
            this.snackbar = true;
            this.progress = false;
          } else {
            this.text1 = "Service Unavailable-bolum";
            this.snackbar = true;
            this.progress = false;
          }
        }
      );
  } else {
    this.kodmesajı = null;
  }
}

function kabul(m) {
  this.val = m.PNR_No;
  this.dialog = false;
}

function dialogac() {
  if (this.satici != undefined) {
    this.pnretiket = this.satici.kod + " Satıcısına ait PNRlar";
  } else {
    this.pnretiket = "Seçili Satıcıya Ait PNRlar";
  }
  if (this.active != true) {
    this.dialog = true;
  }
}

function beforeMount() {}

function kayitgetir(y) {
  if (y != null) {
    if (y.length > 2) {
      this.progress = true;
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
        SectionSearch: escape(y),
      };
      this.$http
        .post(auth.API_URL + "api/Definitions/SectionSearch", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.items = response.body;

            this.progress = false;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-bolum";
              this.snackbar = true;
              this.progress = false;
            } else {
              this.text1 = "Service Unavailable-bolum";
              this.snackbar = true;
              this.progress = false;
            }
          }
        );
    } else {
      this.items = [];
      this.progress = false;
    }
  }
}
</script>